import React from 'react'
import 'Styles/notFoundPage.scss'
import UserSettingsStore from 'Stores/userSettingsStore'

const NotFoundPage = (props) => {
    UserSettingsStore.SetRedirectTo404(false);
    return (
        <div className={ "not-found-page " + (props.className == null ? '' : props.className) }>
            <div className="not-found-page-wall"/>
            <div className="not-found-page-floor"/>
            <div className="not-found-icon"/>
        </div>
    )
};

export default NotFoundPage;